"use client";

import React from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { CircleQuestionMark as HelpCircle } from 'lucide-react';
interface FaqItem {
  id: string;
  question: string;
  answer: string;
}
const FAQ_ITEMS: FaqItem[] = [{
  id: "item-1",
  question: "When should we begin architectural planning for a home renovation?",
  answer: "Most homeowners begin detailed planning 3 to 6 months before their target construction start date. This window allows ample time for structural engineering, interior space reconfiguration, material selections, and municipal permit reviews in Decatur."
}, {
  id: "item-2",
  question: "How do local zoning and historic guidelines impact remodeling plans?",
  answer: "Decatur has distinctive architectural neighborhoods and specific tree canopy, setback, and historic district considerations. Early site surveys and zoning verifications ensure room additions, roofline modifications, and exterior changes align with local municipal guidelines prior to construction."
}, {
  id: "item-3",
  question: "What is the typical sequence of phases in a whole-home remodel?",
  answer: "A project progresses through preliminary design discovery, space planning, detailed selections, pre-construction site evaluations, permitting, demolition, rough-in mechanicals, framing, and final architectural finish carpentry."
}, {
  id: "item-4",
  question: "Can we stay in our home during a major kitchen or bathroom renovation?",
  answer: "Staying in place depends on the scope of work and access to secondary bathrooms or temporary cooking stations. For whole-home transformations or structural reconfiguration, arranging temporary accommodations often speeds up overall construction momentum."
}, {
  id: "item-5",
  question: "How do we prepare our budget for unexpected structural or plumbing updates?",
  answer: "Older residences frequently require electrical panel upgrades, subfloor leveling, or plumbing vent adjustments once walls are opened. We recommend setting aside a 10% to 15% contingency reserve in your initial investment plan for unforeseen hidden conditions."
}];
export default function RemodelFaq() {
  return <section id="remodelplanningfaq" data-nav="light" className="bg-background text-foreground py-20 md:py-28">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary text-secondary-foreground text-xs font-medium tracking-wide mb-4">
            <HelpCircle className="size-3.5 text-chart-1" />
            <span>Planning Guidance</span>
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-normal tracking-tight text-foreground">
            Frequently asked questions about remodeling
          </h2>
          <p className="mt-4 text-muted-foreground text-base sm:text-lg leading-relaxed">
            Essential considerations for architectural planning, municipal guidelines, and project preparations in Decatur.
          </p>
        </div>

        <div className="bg-card/60 backdrop-blur-xs border border-border rounded-xl p-4 sm:p-8 shadow-sm">
          <Accordion type="single" collapsible defaultValue="item-1" className="w-full space-y-3">
            {FAQ_ITEMS.map((faq, index) => <AccordionItem key={faq.id} value={faq.id} data-index={index} className="border border-border/60 bg-card rounded-lg px-4 sm:px-6 transition-colors data-[state=open]:border-chart-1/40 data-[state=open]:shadow-2xs">
                <AccordionTrigger className="text-left font-serif text-lg sm:text-xl font-medium text-foreground py-5 hover:no-underline hover:text-chart-1 transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="font-sans text-muted-foreground text-base leading-relaxed pb-5 pt-1">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}